import React, { Component } from "react"
import { Redirect } from "react-router-dom"
import { Query } from "react-apollo"
import { Helmet } from "react-helmet"
import PDFView from "../../components/PDFView"
import {
  TextArea,
  RelatedPosts,
  PowerBI,
  NewsletterSignup,
  NewsletterModal,
  ShareButtons,
  HtmlEmbed,
} from "../../components/Post"
import Button from "../../components/Button"
import ApolloQueryHandler from "../../shared/apolloQueryHandler"
import { MetaData, structurePostData } from "../../shared/structureData"
import GET_PAGE from "../../graphql/getPage.graphql"
import ArticleHeader from "../../components/Post/ArticleHeader"
import Image from "../../components/Post/Image"
import striptags from "striptags"
import moment from "moment"
import "./post.scss"
import FreeTrialModal from "../../components/FreeTrialModal"
import FreeReportRequest from "../../components/FreeReportRequest"

const scrollCheckpoints = [0, 0.25, 0.5, 0.75, 1]

class Post extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isMobile: false,
    }

    this.lastCheckpoint = 0
  }

  isHeaderImageHidden = () => {
    let hideHeaderImage = false

    if (
      this.props.postType !== "NEWS" &&
      this.props.data.page &&
      this.props.data.page.hideHeaderImage
    ) {
      hideHeaderImage = this.props.data.page.hideHeaderImage
    }

    return hideHeaderImage
  }

  isUserLoggedIn = this.props.viewer && this.props.viewer.isUserAuthenticated

  setLeadImage = () => {
    const { page } = this.props.data

    const leadImage = document.querySelector(".lead-image")

    const isMobile =
      navigator.userAgent.match(/Android/i) ||
      navigator.userAgent.match(/webOS/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/BlackBerry/i) ||
      navigator.userAgent.match(/Windows Phone/i) ||
      this.state.isMobile

    if (
      !this.isHeaderImageHidden() &&
      page.headerImage &&
      page.postType !== "NEWS" &&
      page.postComponents &&
      page.postComponents.length > 0 &&
      leadImage
    ) {
      if (isMobile) {
        this.setState({ isMobile: true })
        leadImage.setAttribute(
          "style",
          `background-image:url(${page.headerImage.mobile.uri});padding-top:50%`
        )
      } else if (
        page.postType !== "NEWS" &&
        page.postComponents &&
        page.postComponents.length > 0
      ) {
        leadImage.setAttribute(
          "style",
          `background-image:url(${page.headerImage.desktop.uri});`
        )
      }
    }
  }

  updateDimensions = () => {
    this.setState({ isMobile: window.innerWidth < 1023 })
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll)
  }

  componentDidMount = () => {
    this.updateDimensions()
    //FIXME: The logic for displaying images / analytics is poorly implemented.
    if (this.props.data && this.props.data.page) {
      try {
        this.props.trackPage(this.props.history.location.pathname, {
          postType: this.props.match.params.type,
          postName: this.props.data.page.title,
        })
      } catch (err) {
        console.error(err)
      }

      if (this.props.data.page.headerImage) {
        if (
          this.props.data.page.headerImage.desktop ||
          this.props.data.page.headerImage.mobile
        ) {
          this.setLeadImage()
        }
      }
    }

    if (this.isUserLoggedIn) {
      let { match } = this.props
      let { page } = this.props.data
      let pageName
      if (
        page.headerImage &&
        (page.headerImage.desktop || page.headerImage.mobile)
      ) {
        this.setLeadImage()
      }

      if (page.postType === "NEWS") {
        document
          .querySelector("#page-container")
          .setAttribute("style", "overflow:hidden;")

        //A HACK
        let scriptTag = document.createElement("script")
        for (let i = 0; i < page.postComponents.length; i++) {
          if (page.postComponents[i].type.toLowerCase() === "script") {
            scriptTag.innerHTML =
              page.postComponents[1].props.dangerouslySetInnerHTML.__html
          }
        }
        document.body.appendChild(scriptTag)
      }

      window.addEventListener("scroll", this.onScroll)
      window.addEventListener("resize", this.updateDimensions)

      switch (match.params.type.toLowerCase()) {
        case "articles":
          pageName = "Article"
          break
        case "newsletters":
          pageName = "Newsletter"
          break
        default:
          pageName = "Post"
          break
      }

      let pageProperties

      if (page) {
        pageProperties = {
          postType: page.postType,
          postName: page.title,
          postId: page.id,
        }

        if (page.createdBy && page.createdBy.length > 0) {
          pageProperties.postAuthors = page.createdBy
        }
      }
      this.props.trackPage(pageName, pageProperties)
    }
  }

  downloadPdf = () => {
    let { page } = this.props.data

    let eventProperties = {
      postType: page.postType,
      postName: page.title,
      postId: page.id,
    }

    if (page.createdBy && page.createdBy.length > 0) {
      eventProperties.postAuthors = page.createdBy
    }

    this.props.trackEvent("Downloaded post", eventProperties)
  }

  onScroll = (e) => {
    let container = document.querySelector(".post-container")
    let topBar = document.querySelector("#TopBar")

    let windowHeight = window.innerHeight - topBar.clientHeight
    let windowScrollHeight = window.scrollY
    let totalScrollHeight = container.clientHeight

    let { page } = this.props.data
    let amountSeen = (windowHeight + windowScrollHeight) / totalScrollHeight

    if (
      this.lastCheckpoint <= scrollCheckpoints.length - 2 &&
      amountSeen >= scrollCheckpoints[this.lastCheckpoint + 1]
    ) {
      const scrollDepth = scrollCheckpoints[this.lastCheckpoint + 1]
      const eventProperties = {
        postType: page.postType,
        postName: page.title,
        postId: page.id,
        scrollDepth,
      }

      this.props.trackEvent("Scrolled on post", eventProperties)

      this.lastCheckpoint += 1
    }
  }

  _renderContent = () => {
    const { page } = this.props.data
    let pageType
    if (page.postType === "NEWS") {
      pageType = "news"
    } else {
      pageType = "post"
    }

    if (!page) return null

    if (page.file) {
      return (
        <div
          className="article-post content-container fixed"
          ref={(el) => (this.container = el)}
        >
          <div className="top-options">
            <div />
            <Button
              href={page.file}
              download={page.file}
              classes={["btn-download"]}
              action={this.downloadPdf}
            >
              <span className="glyphicon glyphicon-download-alt" />
            </Button>
          </div>
          <PDFView url={page.file} withCredentials={false} />
        </div>
      )
    } else if (page.postComponents && page.postComponents.length > 0) {
      let leadImageClassName = "lead-image"

      if (this.isUserLoggedIn) {
        leadImageClassName += " app-article"
      }
      return (
        <article className="article">
          {!this.isHeaderImageHidden() &&
            page.headerImage &&
            (page.headerImage.desktop || page.headerImage.mobile) && (
              <figure className="article__lead-image">
                <div className={leadImageClassName} />
                {page.headerImage &&
                  page.headerImage.desktop &&
                  page.headerImage.desktop.description && (
                    <figcaption className="lead-image__caption">
                      <span className="lead-image__caption--light">
                        Image Credit:
                      </span>{" "}
                      {page.headerImage.desktop.description
                        ? page.headerImage.desktop.description
                        : ""}
                    </figcaption>
                  )}
              </figure>
            )}
          <main className={`article__${pageType} content-container`}>
            {page.postType !== "NEWS" && (
              <ArticleHeader {...this.props.data.page} />
            )}

            {this.renderPostStructure()}
          </main>
        </article>
      )
    }
    return null
  }

  renderPostStructure = () => {
    const { page } = this.props.data
    const freeReportRequestComponent = page.postComponents.filter(
      (component) => component.type === "free-report-request"
    )

    return (
      <section className="article__body">
        <div>{page.postComponents.map(this._renderComponent)}</div>
        {!!freeReportRequestComponent.length && (
          <div className="right">
            <FreeReportRequest
              reportTitle={freeReportRequestComponent[0].props.reportTitle}
              slug={page.slug[0]}
              isMobile={this.state.isMobile}
            />
          </div>
        )}
      </section>
    )
  }

  _renderComponent = (component, i) => {
    const { page } = this.props.data

    let ComponentType
    if (page.postType === "NEWS") {
      ComponentType = component.type
    } else {
      switch (component.type) {
        case "text-content":
          ComponentType = TextArea
          break
        case "powerbi-component":
          ComponentType = PowerBI
          break
        case "newsletter-modal-component":
          ComponentType = NewsletterModal
          break
        case "related-posts":
          ComponentType = RelatedPosts
          break
        case "newsletter-signup":
          ComponentType = NewsletterSignup
          break
        case "image-upload-component":
          ComponentType = Image
          break
        case "html-embed":
          ComponentType = HtmlEmbed
          break
        case "free-trial-modal":
          ComponentType = FreeTrialModal
          break
        default:
          ComponentType = null
          break
      }
    }

    if (!ComponentType) {
      return null
    }

    const props = component.props || {}
    if (page.postType === "NEWS") {
      const publishDate = new Date(
        this.props.data.page.publishDate
      ).toISOString()
      if (ComponentType === "iframe") {
        return (
          <div key={i} className="newsletter-iframe">
            <div className="newsletter-iframe__header">
              <p>{moment(publishDate).format("MMMM DD, YYYY")}</p>
              <ShareButtons
                {...this.props}
                articleSlug={this.props.data.page.slug[0]}
                title={this.props.data.page.title}
                message="Check out this post!"
              />
            </div>
            <ComponentType {...props} />
          </div>
        )
      } else {
        return <ComponentType key={i} {...props} />
      }
    } else {
      return (
        <ComponentType
          key={i}
          {...this.props}
          {...props}
          articleSlug={this.props.data.page.slug[0]}
        />
      )
    }
  }

  render = () => {
    const { page } = this.props.data

    if (!page) {
      return <Redirect to="/" />
    }

    if (!this.isUserLoggedIn && !page.isPublic) {
      let redirectFrom = page.slug ? page.slug[0] : "/newsletter"
      return (
        <Redirect to={{ pathname: "/login", state: { from: redirectFrom } }} />
      )
    }

    const metaSEO = {
      description: page.seo.description,
      title: striptags(page.title),
      image: page.seo.image,
      url: page.seo.url,
      published_time: page.seo.datePublished,
      author: page.createdBy,
      publisher: page.seo.publisher,
      tag: page.seo.keywords,
      articleBody: page.seo.articleBody,
      type: page.seo["@type"],
    }

    return (
      <div className="post-container">
        <Helmet>
          {MetaData(metaSEO)}
          <script type="application/ld+json">
            {structurePostData(metaSEO)}
          </script>
        </Helmet>
        {this._renderContent()}
      </div>
    )
  }
}

const PostWithData = (componentProps) => {
  let slug = null
  let id = componentProps.match.params.id

  if (!id) {
    slug = componentProps.location.pathname
  }

  let type = "post"

  return (
    <Query
      query={GET_PAGE}
      variables={{ slug, id, type }}
      fetchPolicy="network-only"
    >
      {(queryProps) => {
        return (
          <ApolloQueryHandler {...componentProps} {...queryProps}>
            {(props) => <Post {...props} />}
          </ApolloQueryHandler>
        )
      }}
    </Query>
  )
}

export default PostWithData
